const BASE_URL = "https://billing.sibirajanagaimaligai.com";
const WEB_URL  = "https://sibirajanagaimaligai.com";



export { BASE_URL , WEB_URL};
